<modal [closable]="closable">
  <b header>{{title}}</b>
  <p [innerHTML]="message" class="{{class ? class : ''}}"></p>
  <div *ngIf="buttons && buttons.length > 0">
    <button *ngFor="let i of buttons" class="{{i.class ? i.class : ''}}" (click)="click(i)"><i *ngIf="i.icon" class="{{i.icon}}"></i><span *ngIf="i.name">{{i.name}}</span></button>
  </div>
</modal>
